import { get } from 'lodash';

const selectPassengerTypes = (state) => {
  return get(state, 'consumerTypes.passengerTypes');
};

export { selectPassengerTypes };
